class TeamProfileController {
  constructor(
    TeamsFactory,
    AuthFactory,
    PlayersFactory,
    $rootScope,
    $stateParams,
    $filter,
    $state,
    ngDialog,
    URLS
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      vm.options = [
        { id: 1, name: "INFORMATION" },
        { id: 2, name: "PLAYERS" },
      ];
      vm.activeOption = 1;
      vm.teamId = $stateParams.id;
      vm.team = {};
      vm.password = {};
      vm.defaultLat = 39.04157914096756;
      vm.defaultLng = 23.112951828125006;
      if (vm.teamId) {
        TeamsFactory.getOne(vm.teamId, {
          include: "players,state,county,region",
        }).then((response) => {
          vm.team = response.data;
          if (!vm.team.lat || !vm.team.lng) {
            vm.team.lat = vm.defaultLat;
            vm.team.lng = vm.defaultLng;
          }
          vm.gridOptions.data = vm.team.players;
        });
      }
    };

    vm.gridOptions = {
      enableSorting: true,
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "playerName",
          name: $translate("NAME"),
          enableFiltering: true,
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<a href class="btn btn-sm primary" translate ' +
            'ng-click="grid.appScope.vm.goToPlayerProfile(row.entity.player_id)">PROFILE</a>' +
            '<button class="btn btn-sm accent m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' +
            'ng-click="grid.appScope.vm.getPlayerCard(row.entity.player_id)">DOWNLOAD_CARD</button>' +
            "</div>" +
            "</div>",
          width: "400",
        },
      ],
    };

    vm.printCards = () => {
      const tabWindowId = window.open("about:blank", "_blank");
      TeamsFactory.playerCards(vm.teamId).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };

    vm.hasPermission = (permission) => {
      if (vm.rootScope.user.isUserTypeTeam()) {
        return (
          vm.rootScope.user.isTeam(vm.teamId) &&
          vm.rootScope.user.canDo(permission)
        );
      } else {
        return vm.rootScope.user.canDo(permission);
      }
    };

    vm.changePassword = () => {
      vm.password.id = vm.teamId;
      AuthFactory.changePassword(AuthFactory.USER_TYPES.TEAM, vm.password).then(
        (response) => {
          ngDialog.open({ template: "successTemplate" });
        }
      );
    };

    vm.getTeamImage = function () {
      if (vm.team.img) {
        return URLS.IMAGES_URL + "/teams/" + vm.team.img;
      } else {
        return "assets/images/no_avatar.png";
      }
    };

    vm.goToPlayerProfile = (playerId) => {
      $state.go("player-profile", { id: playerId });
    };

    vm.getPlayerCard = (playerId) => {
      const tabWindowId = window.open("about:blank", "_blank");
      PlayersFactory.card(playerId).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };

    vm.getPlayerTrainingCard = (playerId) => {
      const tabWindowId = window.open("about:blank", "_blank");
      PlayersFactory.trainCard(playerId).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };
  }
}

export default TeamProfileController;



// WEBPACK FOOTER //
// ./client/app/components/teams/teamProfile/teamProfile.controller.js